import { Box, Divider, List, ListItem, ListItemText, Typography } from '@mui/material';
import React from 'react';
import { useTypedSelector } from '../../../../store/hooks';
import langFile from '../../../../data/lang.json';

const DepositCalculationData: React.FC = (props) => {
    const { amount, depositInterestTotal, depositTotalAmount, averageDepositReward } = useTypedSelector(state => state.deposit);
    const { lang } = useTypedSelector(state => state.common);
    const format = lang === 'kz' ? 'ru' : lang;

    return (
        <Box>
            <List 
                dense>
                <ListItem
                    secondaryAction={
                        <Typography>{amount.toLocaleString(format)}</Typography>
                    }>
                    <ListItemText
                        primary={(langFile.depositAmount as any)[lang]}
                    />
                </ListItem>
                <Divider />
                <ListItem
                    secondaryAction={
                        <Typography>{depositTotalAmount.toLocaleString(format)}</Typography>
                    }>
                    <ListItemText
                        primary={(langFile.depositTotalAmount as any)[lang]}
                    />
                </ListItem>
                <Divider />
                <ListItem
                    secondaryAction={
                        <Typography>{depositInterestTotal.toLocaleString(format)}</Typography>
                    }>
                    <ListItemText
                        primary={(langFile.depositInterestTotal as any)[lang]}
                    />
                </ListItem>
                <Divider />
                <ListItem
                    secondaryAction={
                        <Typography>{averageDepositReward.toLocaleString(format)}</Typography>
                    }>
                    <ListItemText
                        primary={(langFile.averageDepositReward as any)[lang]}
                    />
                </ListItem>
            </List>
        </Box>
    )
}

export default DepositCalculationData;